import { isChunkLoadError } from './helper'
import {
  APP_UPDATE_EVENT,
  getChunkReloadKey,
  getHashPathname,
  isSafeToReloadPath,
  refreshBrokenChunks,
} from './appUpdate'

function safeReloadOnce(error) {
  // Di halaman input jangan reload — data yang belum disimpan bisa hilang.
  // Cukup munculkan notifikasi versi baru (UpdateAppWrapper).
  if (!isSafeToReloadPath(getHashPathname())) {
    window.dispatchEvent(new Event(APP_UPDATE_EVENT))
    return
  }

  const key = getChunkReloadKey()
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1')
    // Reload saja tidak cukup kalau cache chunk berisi HTML — minta ulang chunk itu dulu
    refreshBrokenChunks(error).finally(() => {
      window.location.reload()
    })
  }
}

window.addEventListener('error', (e) => {
  if (isChunkLoadError(e)) {
    safeReloadOnce(e)
  }
})
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkLoadError(e)) {
    safeReloadOnce(e)
  }
})
